import { useMutation, useQueryClient } from "react-query";
import { Auth } from "../../interface";
import { mutatePostFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useSendNotification = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutatePostFn(ENDPOINTS.SEND_NOTIFICAION, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([]);
      },
    }
  );
};
